"use client";

import { useEffect, useLayoutEffect } from "react";

/**
 * レイアウトを測る副作用。ブラウザーでは useLayoutEffect、それ以外では useEffect を使う。
 *
 * ui-kit はビルドを挟まずソースのまま Web コンソール (Next.js) からも読まれ、そこでは
 * クライアント部品もサーバーで一度描画される。useLayoutEffect はサーバーで実行されず
 * 警告を出すため、環境で切り替える。
 */
export const useIsomorphicLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
